import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';

@Component({
  selector: 'vc-footer-nav-section',
  templateUrl: './footer-nav-section.component.html',
  styleUrls: ['./footer-nav-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterNavSectionComponent {
  @Input()
  home: boolean;
  @Input()
  navigations: any;
  public modifierClass = 0;

  private hiddenPages = ['who-are-we', 'customer-reviews'];

  constructor(private helpersService: HelpersService) {}

  toggleAccordionClass(event) {
    this.modifierClass = this.helpersService.toggleAccordionOpenClass(event);
  }

  isAnchored(content: { mnemonic: string; obfuscate: boolean }): boolean {
    return !content.obfuscate && (this.home || (!this.home && !this.hiddenPages.includes(content.mnemonic)));
  }
}
